import React from 'react';
import { CheckIcon, StarIcon } from 'lucide-react';
interface PricingCardProps {
  idAttr?: string;
}
export function PricingCard({
  idAttr = 'pricing'
}: PricingCardProps) {
  return <section id={idAttr} className="py-8 px-4 bg-white scroll-mt-10" data-id="element-112">
      <div className="max-w-3xl mx-auto" data-id="element-113">
        <div className="text-center mb-8" data-id="element-114">
          <h2 className="text-xl sm:text-2xl font-heading font-bold text-brand-primary mb-2" data-id="element-115">
            💰 L'Offerta "Tiroide Felice"
          </h2>
        </div>

        <div className="space-y-6" data-id="element-116">
          {/* TIER 1: Ebook Principale */}
          <div className="bg-brand-bg border-2 border-brand-border rounded-lg p-6" data-id="element-117">
            <div className="mb-4" data-id="element-118">
              <div className="flex items-center gap-2 mb-3" data-id="element-119">
                <CheckIcon className="w-5 h-5 text-brand-primary" data-id="element-120" />
                <span className="text-sm" data-id="element-121">
                  Ebook Principale (60 Ricette Tiroide) — €97
                </span>
              </div>
              <div className="flex items-center gap-2 mb-3" data-id="element-122">
                <CheckIcon className="w-5 h-5 text-brand-primary" data-id="element-123" />
                <span className="text-sm" data-id="element-124">
                  Lista della Spesa Strategica — €19
                </span>
              </div>
              <div className="flex items-center gap-2 mb-3" data-id="element-125">
                <CheckIcon className="w-5 h-5 text-brand-primary" data-id="element-126" />
                <span className="text-sm" data-id="element-127">
                  Piano Settimanale & Combinazioni — €27
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-128">
                <CheckIcon className="w-5 h-5 text-brand-primary" data-id="element-129" />
                <span className="text-sm" data-id="element-130">3 Bonus Esclusivi — €59</span>
              </div>
            </div>

            <div className="border-t border-brand-border pt-4 mb-4" data-id="element-131">
              <div className="flex items-baseline gap-2 mb-1" data-id="element-132">
                <span className="text-sm text-brand-muted uppercase font-bold tracking-wider" data-id="element-133">
                  VALORE REALE:
                </span>
                <span className="text-lg line-through text-brand-muted" data-id="element-134">
                  €202,00
                </span>
              </div>
              <div className="flex items-baseline gap-2" data-id="element-135">
                <span className="text-sm text-brand-accent uppercase font-bold tracking-wider" data-id="element-136">
                  90% di Sconto — Offerta Lancio
                </span>
              </div>
              <div className="text-3xl font-bold text-brand-primary mt-2" data-id="element-137">
                SOLO €19,90
              </div>
              <p className="text-xs text-brand-muted mt-1" data-id="element-138">
                💳 Pagamento unico • ⚡ Accesso immediato
              </p>
            </div>

            <a href="https://italia.kitonline.shop/cart/44759694901383:1" className="block w-full bg-brand-accent hover:bg-brand-accentHover text-white font-bold py-4 px-6 rounded-lg uppercase tracking-wide text-sm text-center transition-colors" data-id="element-139">
              🚀 SÌ! VOGLIO IL KIT COMPLETO
            </a>
          </div>

          {/* TIER 2: Protocollo Completo (RECOMMENDED) */}
          <div className="bg-brand-primary text-white border-2 border-brand-accent rounded-lg p-6 relative" data-id="element-140">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-accent text-white font-bold px-4 py-1 rounded-full text-xs uppercase flex items-center gap-1" data-id="element-141">
              <StarIcon className="w-3 h-3 fill-current" data-id="element-142" />
              LA PIÙ SCELTA
            </div>

            <h3 className="text-lg font-bold mb-4 mt-2" data-id="element-143">
              Protocollo Completo "Trasformazione 360°"
            </h3>

            <div className="mb-4 space-y-2" data-id="element-144">
              <div className="flex items-center gap-2" data-id="element-145">
                <CheckIcon className="w-5 h-5 text-brand-accent" data-id="element-146" />
                <span className="text-sm" data-id="element-147">60 Ricette per la Tiroide</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-148">
                <CheckIcon className="w-5 h-5 text-brand-accent" data-id="element-149" />
                <span className="text-sm" data-id="element-150">I 3 Bonus Inclusi</span>
              </div>
              <div className="bg-white/10 p-3 rounded-lg mt-3" data-id="element-151">
                <div className="flex items-start gap-2" data-id="element-152">
                  <CheckIcon className="w-5 h-5 text-brand-accent shrink-0 mt-0.5" data-id="element-153" />
                  <div data-id="element-154">
                    <span className="text-sm font-bold text-brand-accent block mb-1" data-id="element-155">
                      + Protocollo Tiroide 360°
                    </span>
                    <span className="text-xs opacity-90" data-id="element-156">
                      La Soluzione Definitiva per il Risveglio Ormonale (Guida
                      all'Integrazione, Gestione del Cortisolo e Strategie
                      Anti-Invecchiamento Metabolico).
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="border-t border-white/20 pt-4 mb-4" data-id="element-157">
              <div className="text-sm uppercase font-bold tracking-wider mb-2 opacity-80" data-id="element-158">
                PREZZO SPECIALE BUNDLE:
              </div>
              <div className="text-4xl font-bold mb-1" data-id="element-159">€27,90</div>
              <p className="text-xs opacity-80" data-id="element-160">
                (Risparmi oltre €50 rispetto all'acquisto separato)
              </p>
            </div>

            <a href="https://italia.kitonline.shop/cart/44759699554439:1" className="block w-full bg-brand-accent hover:bg-brand-accentHover text-white font-bold py-4 px-6 rounded-lg uppercase tracking-wide text-sm text-center transition-colors" data-id="element-161">
              🚀 SÌ! VOGLIO IL PROTOCOLLO COMPLETO
            </a>
          </div>
        </div>
      </div>
    </section>;
}